/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* @flow */
export default {
  green_10: '#e8fcf2',
  green_20: '#c0fadc',
  green_30: '#95f5c3',
  green_40: '#67eba7',
  green_50: '#40db8d',
  green_60: '#1fc06f',
  green_70: '#10a35a',
  green_80: '#0a8f4c',
  green_90: '#06783f',
  green_100: '#046132',

  a11y_text_light: [90, 100]
};



// WEBPACK FOOTER //
// ./src/colors/green.js